export enum EventType {
  Camp = 'camp',
  Course = 'course',
  Event = 'event',
  Training = 'training',
  Class = 'class',
  Workshop = 'workshop',
  OpenTraining = 'openTraining',
  Education = 'education',
  Retreat = 'retreat',
  Private = 'private',
  Rental = 'rental',
}

export const EventTypeTrackingLabel: Record<EventType, string> = {
  [EventType.Camp]: 'camp',
  [EventType.Course]: 'course',
  [EventType.Event]: 'event',
  [EventType.Training]: 'training',
  [EventType.Class]: 'class',
  [EventType.Workshop]: 'workshop',
  [EventType.OpenTraining]: 'openTraining',
  [EventType.Education]: 'education',
  [EventType.Retreat]: 'retreat',
  [EventType.Private]: 'Private Session',
  [EventType.Rental]: 'Rental',
}

export const SingleSessionEventTypes = [EventType.Class, EventType.Training, EventType.OpenTraining]

export const PrivateSessionEventTypes = [EventType.Private]

export const CourtRentalEventTypes = [EventType.Rental]

export const MultiSessionEventTypes = [
  EventType.Camp,
  EventType.Course,
  EventType.Event,
  EventType.Workshop,
  EventType.Retreat,
  EventType.Education,
]
